const NAMESPACE = "equipmentgroup";

const KEYS = {
    batterySectionLabel: "batterySectionLabel",
    deleteBatteryButtonText: "deleteBatteryButtonText",
    batteryRatingLabel: "batteryRatingLabel",
    updatedModelSuffix: "updatedModelSuffix"
};

const MESSAGES = {
    [KEYS.batterySectionLabel]: {
        value: "Battery",
        comment: "Label for Battery section"
    },
    [KEYS.deleteBatteryButtonText]: {
        value: "Delete Battery",
        comment: "Text for button to delete battery"
    },
    [KEYS.updatedModelSuffix]: {
        value: " - UPDATED",
        comment: "Suffix to use on a model which is an updated version of the stored model"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
